import { render, staticRenderFns } from "./TutorSubjectsList.vue?vue&type=template&id=15fd4cca&"
import script from "./TutorSubjectsList.vue?vue&type=script&lang=js&"
export * from "./TutorSubjectsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports